import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG } from '@digilize/shared/utils/tokens';
import { EnvConfig } from '@shared/definitions';
import { Observable } from 'rxjs';
import { PosDto } from '@plys/src/infrastructure/dto/pos.dto';

@Injectable({
  providedIn: 'root',
})
export class PosService {
  constructor(@Inject(ENV_CONFIG) private readonly config: EnvConfig, private readonly client: HttpClient) {}

  /**
   * Prefetched during HTML parse by the inline script in the three `index.*.html` files and claimed
   * by `BootstrapPrefetchInterceptor`, which matches this URL literally. Change it and the head
   * start is silently lost — the call just runs normally — so keep the three index files and
   * the interceptor in sync. See `application/bootstrap-prefetch.ts`.
   */
  getPosById(id: string): Observable<PosDto> {
    return this.client.get<PosDto>(`${this.config.api}/v1.0/pos/${id}`);
  }
}
